import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FullCalendar from "@fullcalendar/react";
import dayGridWeek from "@fullcalendar/daygrid";
import timeGridWeek from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import AddEventsModal from "../Common/modals/AddEventsModal";
import { ApiHook } from "../../hooks/apiHook";
import { useQueryClient } from "@tanstack/react-query";
import dayjs from "dayjs";

import GoogleLoginModal from "../Common/modals/GoogleLoginModal";
import { BackHandRounded } from "@mui/icons-material";
// Replace with your actual Client ID

const Events = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const [eventFormData, setEventFormData] = useState({
    leadId: "",
    eventName: "",
    eventDescription: "",
    eventDate: "",
    eventendTime: "",
    eventstartTime: "",
    eventStatus: "",
    leadStatus: "",
  });
  const [showEventModal, setEventModal] = useState(false);
  const [googleId, setGoogleId] = useState(null);
  const { data, isLoading } = ApiHook.CallLeadesByStatus();
  const addLeadstatusMutation = ApiHook.AddLeadStatusChange();
  const addLeadEventsMutation = ApiHook.AddLeadEvents();
  const eventsData = ApiHook.GetLeadEvents();
  const [googleSignIn, setGooglesignIn] = useState(false);
  const [credentails, setGoogleCredentails] = useState("");
  const [events, setEvents] = useState([]);
  const [errorMessage, setErrorMessage] = useState({
    leadId: null,
    eventDescription: null,
    eventDate: null,
    eventStatus: null,
    leadStatus: null,
  });
  const [requiredFileds, setRequiredFileds] = useState({
    leadId: null,
    eventDescription: null,
    eventDate: null,
    eventStatus: null,
    leadStatus: null,
  });

  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const onSuccess = async (response) => {
    try {
      console.log(response);
      setGoogleId(response?.code);
      setGoogleCredentails(response?.code);
      setGooglesignIn(false);
    } catch (error) {
      console.error("Auth Error:", error);
    }
  };

  const onFailure = (error) => {
    console.error("Login Failed:", error);
  };

  const handleDateClick = async (info) => {
    setEventModal(true);
  };

  const setEventModalData = (leadeDetails, stepDetails) => {
    setEventModal(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!googleId) {
      setGooglesignIn(true);
    } else {
      let errors = {};

      // Validate eventFormData fields instead of errorMessage
      const requiredFields = [
        "leadId",
        "eventDescription",
        "eventDate",
        "eventStatus",
        "leadStatus",
      ];

      requiredFields.forEach((key) => {
        if (!eventFormData[key]) {
          // Checks for null, undefined, or empty string
          errors[key] = `${key} cannot be empty`;
        }
      });

      if (Object.keys(errors).length > 0) {
        setErrorMessage(errors); // Set error messages if there are validation errors
        return;
      }

      // Clear previous error messages
      setErrorMessage({});

      // Find funnel stage data
      const funnalStagedata = data?.funnalStages.find(
        (obj) => obj.id == eventFormData?.leadStatus
      );

      // Update eventFormData fields
      const updatedEventFormData = {
        ...eventFormData,
        eventName: funnalStagedata?.name,
        googleClintId: googleId,
        code: credentails,
      };

      // Submit the data
      addLeadEventsMutation.mutate(
        { eventFormData: updatedEventFormData },
        {
          onSuccess: (res) => {
            if (res.status) {
              setEventModal(false);
              setEventFormData({
                eventId: "",
                leadId: "",
                leadName: "",
                eventType: "",
                leadStatus: "",
                eventName: "",
                eventDescription: "",
                eventDate: "",
                eventStatus: "",
              });

              queryClient.invalidateQueries({ queryKey: ["crm-lead-events"] });
            } else {
              // toast.error(res?.message); // Uncomment if using toast notifications
            }
          },
        }
      );
    }
  };

  useEffect(() => {
    if (eventsData) {
      setEvents(eventsData?.data?.crmEvents);
    }
  }, [eventsData]);

  const handleInputChange = (e) => {
    const { value, name } = e.target;
    setEventFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleEventClick = (e) => {
    console.log(e.event.id, events);
    const eventsDetails = events.find(
      (obj) => obj.id == e.event.id // Use "===" for comparison
    );
    const formattedDate = dayjs(eventsDetails?.start);
    setEventFormData((prevState) => ({
      ...prevState,
      leadId: eventsDetails?.crmLeadId,
      leadName: eventsDetails?.crmLeadId,
      eventType: eventsDetails?.title,
      leadStatus: eventsDetails?.salesStageId,
      eventName: eventsDetails?.title,
      eventDescription: eventsDetails?.eventDescription,
      eventDate: formattedDate,
      eventStatus: eventsDetails?.eventStatus,
      eventId: eventsDetails?.id,
    }));
    setErrorMessage((prevState) => ({
      ...prevState,
      leadId: null,
      eventDescription: null,
      eventDate: null,
      eventStatus: null,
      leadStatus: null,
    }));

    setEventModal(true);
  };

  // function renderEventContent(eventInfo) {
  //   const eventsDetails = events.find((obj) => obj.id == eventInfo?.event.id);

  //   return (
  //     <div
  //       style={{
  //         borderColor: getRandomColor(),
  //         color: getRandomColor(),
  //         // display: "flex",
  //         // justifyContent: "space-evenly",
  //       }}
  //     >
  //       <ul class="a">
  //         <li>
  //           {eventInfo.timeText} - {eventsDetails.eventDescription}{" "}
          
  //         </li>

          
  //       </ul>
  //     </div>
  //   );
  // }

  function renderEventContent(eventInfo) {
  const eventsDetails = events.find((obj) => obj.id == eventInfo?.event.id);

  
  // Fallback in case event details aren't found
  if (!eventsDetails) {
    return (
      <div className="event-content">
        <div className="event-time">{eventInfo.timeText}</div>
        <div className="event-title">Event not found</div>
      </div>
    );
  }

  return (
    <div 
      className="event-content"
      style={{
        borderLeft: `4px solid ${getRandomColor()}`,
        padding: '2px 4px',
        color: getRandomColor(),
        fontSize: '0.85em',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
    >
      <div className="event-time" style={{ fontWeight: 'bold' }}>
        {eventInfo.timeText} 
      </div>
      <div className="event-description">
        {eventsDetails.eventDescription}
      </div>
    </div>
  );
}

  return (
    <div className="row tree_view_content_section">
       <div className="col-12">
      {!eventsData.isLoading && (
        <>
            <div className="calendar-wrapper">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            editable={false}
            selectable={false}
            dayMaxEvents={true}
            events={events}
            eventDisplay="list"
            eventOrder="true"
            // dateClick={setEventModalData}
            // eventClick={handleEventClick}
            eventContent={renderEventContent}
            headerToolbar={{
              left: "dayGridMonth,timeGridWeek,timeGridDay",
              center: "title",
              right: "prevYear,prev,next,nextYear",
            }}
            height={700}
            //validRange={{ start: new Date() }}
          />
          <GoogleLoginModal
            googleSignIn={googleSignIn}
            setGooglesignIn={setGooglesignIn}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />

          <AddEventsModal
            setEventModal={setEventModal}
            setEventFormData={setEventFormData}
            eventFormData={eventFormData}
            showEventModal={showEventModal}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            leadList={data?.leadList}
            funnalStages={data?.funnalStages}
            onSuccess={onSuccess}
            onFailure={onFailure}
            setErrorMessage={setErrorMessage}
            errorMessage={errorMessage}
          />
          </div>
        </>
      )}
      </div>
    </div>
  );
};

export default Events;
